const GET_DOCUMENT_TYPE = "GET_DOCUMENT_TYPE";
const GET_DOCUMENT_TYPE_SUCCESS = "GET_DOCUMENT_TYPE_SUCCESS";
const GET_DOCUMENT_TYPE_FAIL = "GET_DOCUMENT_TYPE_FAIL";
 

const BASE_ENDPOINT = "/MasterData";
const initialValues = {
  loading: false,
  hasError: false,
  data:[]
};

const documentType = (state = initialValues, action) => {
  switch (action.type) {
    case GET_DOCUMENT_TYPE: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_DOCUMENT_TYPE_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      };
    }

    case GET_DOCUMENT_TYPE_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }

    default: {
      return state;
    }
  }
};

export const getDocumentType = () => {
  return {
    type: GET_DOCUMENT_TYPE,
    payload: {
      request: {
        method: "GET",
        url: BASE_ENDPOINT + "/Document/Types",
      },
    },
  };
};

export default documentType;
